module.exports = __webpack_public_path__ + "img/ic01.0dde5300.png";